import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import Vue from 'vue';

function register() {
    const componentsFolder = require.context('./components', false, /\w+\.(vue|js)$/);
    const sectionsFolder = require.context('./sections', false, /\w+\.(vue|js)$/);

    componentsFolder.keys().forEach(registerComponents);
    sectionsFolder.keys().forEach(registerSection);

    function registerComponents(fileName: string, index: number, array: any) {
        const componentConfig = componentsFolder(fileName);
        // Get PascalCase name of component
        const componentName = upperFirst(
            camelCase(
                // Strip the leading `./` and extension from the filename
                fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
            )
        );
        console.log('registering', componentName);
        // Register component globally
        Vue.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig
        );
    }

    function registerSection(fileName: string, index: number, array: any) {
        const componentConfig = sectionsFolder(fileName);
        // Get PascalCase name of component
        const componentName = upperFirst(
            camelCase(
                // Strip the leading `./` and extension from the filename
                fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
            )
        );
        console.log('registering', componentName);
        // Register component globally
        Vue.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig
        );
    }
}

export default register;
